import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { isLocal } from '../config/env';

const GoogleMapsContext = createContext();

// In local environments, prefer the dev-only API key if available
const googleMapsApiKey = isLocal
  ? process.env.REACT_APP_GOOGLE_MAPS_API_KEY_FRONTEND_DEV_ONLY ||
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  : process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Must be defined outside the component — a new array reference on every render
// causes @react-google-maps/api to warn and potentially re-trigger script loading.
// 'maps' is NOT a valid legacy library (it belongs to the new importLibrary() API);
// passing it here throws InvalidValueError: unknown libraries: maps.
const GOOGLE_MAPS_LIBRARIES = ['places', 'visualization'];

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey,
    libraries: GOOGLE_MAPS_LIBRARIES
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (context === undefined) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return context;
};
